import { createSearchParams } from "react-router";

import { ROUTES } from "~/constants/routing";

export const buildSearchResultsUrl = (qs = "", hash = ""): string => {
  const search = qs ? createSearchParams({ qs }).toString() : "";
  const url = ROUTES.search.createURL(search);

  return hash ? `${url}#${hash}` : url;
};
